"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#000001",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M12.761 11.388 15.74 8h-.706l-2.585 2.941L10.382 8H8l3.123 4.448L8 16h.706l2.73-3.106L13.619 16H16zm-.967 1.099-.316-.443L8.96 8.52h1.084l2.032 2.844.316.443 2.642 3.697H13.95z"
  })]
}), 'XRing');
//# sourceMappingURL=index.js.map